import React from 'react';

export const BannersList = React.lazy(() =>
  import('@/features/banners').then(({ BannersList }) => ({ default: BannersList })),
);

export const BannerForm = React.lazy(() =>
  import('@/features/banners').then(({ BannerForm }) => ({ default: BannerForm })),
);

export const DiscountsList = React.lazy(() =>
  import('@/features/discounts').then(({ DiscountsList }) => ({ default: DiscountsList })),
);

export const DiscountForm = React.lazy(() =>
  import('@/features/discounts').then(({ DiscountForm }) => ({ default: DiscountForm })),
);

export const DeepLinksManagementPage = React.lazy(() =>
  import('@/features/deepLinks').then(({ DeepLinksManagementPage }) => ({
    default: DeepLinksManagementPage,
  })),
);

export const UsersList = React.lazy(() =>
  import('@/features/users').then(({ UsersList }) => ({ default: UsersList })),
);

export const UserForm = React.lazy(() =>
  import('@/features/users').then(({ UserForm }) => ({ default: UserForm })),
);

export const DsAgentsList = React.lazy(() =>
  import('@/features/dsAgents').then(({ DsAgentsList }) => ({ default: DsAgentsList })),
);

export const DsAgentForm = React.lazy(() =>
  import('@/features/dsAgents').then(({ DsAgentForm }) => ({ default: DsAgentForm })),
);

export const CustomersList = React.lazy(() =>
  import('@/features/customers').then(({ CustomersList }) => ({ default: CustomersList })),
);

export const CustomerOverview = React.lazy(() =>
  import('@/features/customers').then(({ CustomerOverview }) => ({ default: CustomerOverview })),
);

export const PaymentRetriesList = React.lazy(() =>
  import('@/features/paymentRetries').then(({ PaymentRetriesList }) => ({
    default: PaymentRetriesList,
  })),
);

export const AuditLogsPage = React.lazy(() =>
  import('@/features/auditLogs').then(({ AuditLogsPage }) => ({ default: AuditLogsPage })),
);

export const ReplacementBatchesList = React.lazy(() =>
  import('@/features/replacementBatches').then(({ ReplacementBatchesList }) => ({
    default: ReplacementBatchesList,
  })),
);

export const ReplacementBatchForm = React.lazy(() =>
  import('@/features/replacementBatches').then(({ ReplacementBatchForm }) => ({
    default: ReplacementBatchForm,
  })),
);

export const ReplacementBatchDetails = React.lazy(() =>
  import('@/features/replacementBatches').then(({ ReplacementBatchDetails }) => ({
    default: ReplacementBatchDetails,
  })),
);

export const RemovalBatchesList = React.lazy(() =>
  import('@/features/removalBatches').then(({ RemovalBatchesList }) => ({
    default: RemovalBatchesList,
  })),
);

export const RemovalBatchForm = React.lazy(() =>
  import('@/features/removalBatches').then(({ RemovalBatchForm }) => ({
    default: RemovalBatchForm,
  })),
);

export const RemovalBatchDetails = React.lazy(() =>
  import('@/features/removalBatches').then(({ RemovalBatchDetails }) => ({
    default: RemovalBatchDetails,
  })),
);

export const TrialFunnelLogsPage = React.lazy(() =>
  import('@/features/trialFunnelLogs').then(({ TrialFunnelLogsPage }) => ({
    default: TrialFunnelLogsPage,
  })),
);

export const ProductsList = React.lazy(() =>
  import('@/features/products').then(({ ProductsList }) => ({ default: ProductsList })),
);

export const ProductOrderingPage = React.lazy(() =>
  import('@/features/productOrdering').then(({ ProductOrderingPage }) => ({
    default: ProductOrderingPage,
  })),
);

export const ProductForm = React.lazy(() =>
  import('@/features/products').then(({ ProductForm }) => ({ default: ProductForm })),
);

export const BrokenSubscriptionsPage = React.lazy(() =>
  import('@/features/brokenSubscriptions').then(({ BrokenSubscriptionsPage }) => ({
    default: BrokenSubscriptionsPage,
  })),
);

export const BrokenSubscriptionDetailPage = React.lazy(() =>
  import('@/features/brokenSubscriptions').then(({ BrokenSubscriptionDetailPage }) => ({
    default: BrokenSubscriptionDetailPage,
  })),
);

export const TrialWebhookReprocessPage = React.lazy(() =>
  import('@/features/trialWebhooks').then(({ TrialWebhookReprocessPage }) => ({
    default: TrialWebhookReprocessPage,
  })),
);

export const UpsellConfigPage = React.lazy(() =>
  import('@/features/upsellConfig').then(({ UpsellConfigPage }) => ({ default: UpsellConfigPage })),
);

export const RafSettingsPage = React.lazy(() =>
  import('@/features/rafSettings').then(({ RafSettingsPage }) => ({ default: RafSettingsPage })),
);

export const RolesList = React.lazy(() =>
  import('@/features/roles').then(({ RolesList }) => ({ default: RolesList })),
);

export const RoleForm = React.lazy(() =>
  import('@/features/roles').then(({ RoleForm }) => ({ default: RoleForm })),
);
